<app-progress-bar-loader *ngIf="isLoading" [loadingText]="loadingText" [isError]="isError" [errorMessage]="errorMessage" [override_Eta]="etaValue"></app-progress-bar-loader>
<div *ngIf="!isLoading" class="industry-analysis-container">
    <div *ngIf="currentStage > 1" class="header-controls">
        <div class="left-controls">

            <button mat-icon-button (click)="goBack()" class="back-button">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <span class="title">{{ titleText }}</span>
        </div>
        <div class="right-controls">
            <button class="assist-button cancel-button" *ngIf="currentStage==3" (click)="toggleAssistMode()">{{assistMode?"Unassist":"Assist"}}</button>
            <button class="cancel-button" (click)="onClickCancel()">Cancel</button>
            <button class="primary-button" *ngIf="currentStage==2" (click)="proceedToTargetLinks()">Next</button>
            <button class="primary-button" *ngIf="currentStage==3" (click)="proceedToClaimChartGeneration()">Next</button>
            <button class="primary-button" *ngIf="currentStage==4" (click)="proceedToSummary()">Next</button>
            <button class="primary-button" *ngIf="currentStage==5" (click)="onFinalNext()">Next</button>
        </div>
    </div>

    <div *ngIf="currentStage === 2" class="table-container revenue-identification">
        <table>
            <thead>
                <tr>
                    <th>S. No.</th>
                    <th>Patent Number</th>
                    <th>Current Assignee</th>
                    <th>
                        <input type="checkbox" [checked]="allCompaniesChecked()" (change)="toggleAllCompanies($event)"> Targeted Company</th>
                    <!-- <th>Company Revenue</th> -->
                    <th>
                        <input type="checkbox" [checked]="allCompaniesChecked()" (change)="toggleAllCompanies($event)"> Targeted Product</th>
                    <!-- <th>Product Revenue</th> -->
                    <th>Global Headquarters</th>
                    <th>US Headquarters</th>
                    <th>State of Incorporation</th>
                </tr>
            </thead>
            <tbody class="limited-div-container">
                <tr *ngFor="let patent of patentDetails; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>
                        <!-- {{ patent.patentNumber }} -->
                        <a href="https://patents.google.com/patent/{{ patent.patentNumber }}" target="_blank">
                            {{ patent.patentNumber  }}
                        </a>
                    </td>
                    <td>{{patent.currentAssignee}}</td>
                    <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <div class="d-flex align-items-center justify-content-start">
                                <input type="checkbox" [checked]="getCompanyCheckboxChecked(company, patent.patentNumber)" (change)="handleCompanyCheckboxChange(company, patent.patentNumber, $event.target)"> <span appTruncateTextWidth>{{ company.name }}</span>
                            </div>
                            <ng-container *ngFor="let product of company.products;let k= index">
                                <div *ngIf="k!=0" [class.last-item]="k==company.products.length-1">
                                </div>
                            </ng-container>
                        </ng-container>
                    </td>
                    <!-- <td>
                        <ng-container *ngFor="let company of patent.companies">

                            <div class="revenue-edit-controls">
                                <button *ngIf="assistMode" class="img-icon-button" (click)="showRevenueControls(company)">
                                <img *ngIf="company.showRevenue" src="assets/images/checkmark.png">
                                <img *ngIf="!company.showRevenue" src="assets/images/plier-icon.png">
                            </button>
                                <div>
                                    {{ company.companyInfo.Revenue.response }}
                                   
                                </div>
                                <ng-container *ngIf="assistMode">
                                    <button *ngIf="company.showRevenue" class="img-icon-button" (click)="openPopup(patent.patentNumber, '', company.name)">
                    <img src="assets/images/edit-link-icon.png">
                </button>
                                    <button *ngIf="company.showRevenue" class="img-icon-button" (click)="openFileUploadPopup(patent.patentNumber, '', company.name)">
                    <img src="assets/images/upload-file-icon.png">
                </button>
                                </ng-container>
                            </div>


                            <ng-container *ngFor="let product of company.products;let k= index">
                                <div *ngIf="k!=0" [class.last-item]="k==company.products.length-1">
                                </div>
                            </ng-container>
                        </ng-container>

                    </td> -->
                    <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <ng-container *ngFor="let product of company.products;let ind=index">

                                <div class="d-flex align-items-center justify-content-start" [class.last-item]="ind==company.products.length-1">
                                    <input type="checkbox" [checked]="getProductCheckboxChecked(product, company, patent.patentNumber)" (change)="handleProductCheckboxChange(product, company, patent.patentNumber,  $event.target)"> <span appTruncateTextWidth>{{ product.name }}</span>
                                </div>
                            </ng-container>
                        </ng-container>
                    </td>
                    <!-- <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <div class="revenue-edit-controls" *ngFor="let product of company.products;let ind=index">
                                <button *ngIf="assistMode" class="img-icon-button" (click)="showProductRevenueControls(product)">
                                <img *ngIf="product.showRevenue" src="assets/images/checkmark.png">
                                <img *ngIf="!product.showRevenue" src="assets/images/plier-icon.png">
                            </button>
                                <div [class.last-item]="ind==company.products.length-1">
                                    {{ product.revenue.response }}
                                   
                                </div>
                                <ng-container *ngIf="assistMode">

                                    <button *ngIf="product.showRevenue" class="img-icon-button" (click)="openPopup(patent.patentNumber, product.name, company.name)">
                                    <img src="assets/images/edit-link-icon.png">
                                </button>
                                    <button *ngIf="product.showRevenue" class="img-icon-button" (click)="openFileUploadPopup(patent.patentNumber, product.name, company.name)">
                                    <img src="assets/images/upload-file-icon.png">
                                </button>
                                </ng-container>
                            </div>
                        </ng-container>
                    </td> -->
                    <td>
                        <ng-container *ngFor="let company of patent.companies; let j=index">
                            <ng-container *ngIf="company.new!=true">
                                <div>

                                    {{ company.companyInfo["Global Headquarters"]["response"] }}
                                </div>
                                <ng-container *ngFor="let product of company.products;let i= index">
                                    <div *ngIf="i!=0" [class.last-item]="i==company.products.length-1">
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </td>
                    <td>
                        <ng-container *ngFor="let company of patent.companies; let j=index">
                            <ng-container *ngIf="company.new!=true">
                                <div>

                                    {{ company.companyInfo["US Headquarters"]["response"] }}
                                </div>
                            </ng-container>
                            <ng-container *ngFor="let product of company.products;let i= index">
                                <div *ngIf="i!=0" [class.last-item]="i==company.products.length-1">
                                </div>
                            </ng-container>
                        </ng-container>
                    </td>
                    <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <ng-container *ngIf="company.new!=true">
                                <div>

                                    {{ company.companyInfo["State of Incorporation"]["response"] }}
                                </div>
                                <ng-container *ngFor="let product of company.products;let i= index">
                                    <div *ngIf="i!=0" [class.last-item]="i==company.products.length-1">
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-container>

                    </td>

                </tr>
            </tbody>
        </table>

    </div>
    <div *ngIf="currentStage === 3" class="table-container revenue-identification">
        <table>
            <thead>
                <tr>
                    <th>S. No.</th>
                    <th>Patent Number</th>
                    <th>Current Assignee</th>
                    <th>Targeted Company</th>
                    <!-- <th>Company Revenue</th> -->
                    <th>Targeted Product</th>
                    <!-- <th>Product Revenue</th> -->
                    <th>Global Headquarters</th>
                    <th>US Headquarters</th>
                    <th>State of Incorporation</th>
                    <th>Technical Documentation Links</th>
                </tr>
            </thead>
            <tbody class="limited-div-container">
                <tr *ngFor="let patent of patentDetails; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>
                        <!-- {{ patent.patentNumber }} -->
                        <a href="https://patents.google.com/patent/{{ patent.patentNumber }}" target="_blank">
                            {{ patent.patentNumber  }}
                        </a>
                    </td>
                    <td>{{patent.currentAssignee}}</td>
                    <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <div>
                                {{ company.name }}
                            </div>
                            <ng-container *ngFor="let product of company.products;let k= index">
                                <div *ngIf="k!=0" [class.last-item]="k==company.products.length-1">
                                </div>
                            </ng-container>
                        </ng-container>
                    </td>
                    <!-- <td>
                        <ng-container *ngFor="let company of patent.companies">

                            <div class="revenue-edit-controls">
                               
                                <div>
                                    {{ company.companyInfo.Revenue.response }}
                                   
                                </div>
                                <ng-container *ngIf="assistMode">
                                    <button *ngIf="company.showRevenue" class="img-icon-button" (click)="openPopup(patent.patentNumber, '', company.name)">
                    <img src="assets/images/edit-link-icon.png">
                </button>
                                    <button *ngIf="company.showRevenue" class="img-icon-button" (click)="openFileUploadPopup(patent.patentNumber, '', company.name)">
                    <img src="assets/images/upload-file-icon.png">
                </button>
                                </ng-container>
                            </div>


                            <ng-container *ngFor="let product of company.products;let k= index">
                                <div *ngIf="k!=0" [class.last-item]="k==company.products.length-1">
                                </div>
                            </ng-container>
                        </ng-container>

                    </td> -->
                    <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <ng-container *ngFor="let product of company.products;let ind=index">

                                <div [class.last-item]="ind==company.products.length-1">
                                    {{ product.name }}
                                </div>
                            </ng-container>
                        </ng-container>
                    </td>
                    <!-- <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <div class="revenue-edit-controls" *ngFor="let product of company.products;let ind=index">
                             
                                <div [class.last-item]="ind==company.products.length-1">
                                    {{ product.revenue.response }}
                                    
                                </div>
                               
                            </div>
                        </ng-container>
                    </td> -->
                    <td>
                        <ng-container *ngFor="let company of patent.companies; let j=index">
                            <ng-container *ngIf="company.new!=true">
                                <div>

                                    {{ company.companyInfo["Global Headquarters"]["response"] }}
                                </div>
                                <ng-container *ngFor="let product of company.products;let i= index">
                                    <div *ngIf="i!=0" [class.last-item]="i==company.products.length-1">
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </td>
                    <td>
                        <ng-container *ngFor="let company of patent.companies; let j=index">
                            <ng-container *ngIf="company.new!=true">
                                <div>

                                    {{ company.companyInfo["US Headquarters"]["response"] }}
                                </div>
                            </ng-container>
                            <ng-container *ngFor="let product of company.products;let i= index">
                                <div *ngIf="i!=0" [class.last-item]="i==company.products.length-1">
                                </div>
                            </ng-container>
                        </ng-container>
                    </td>
                    <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <ng-container *ngIf="company.new!=true">
                                <div>

                                    {{ company.companyInfo["State of Incorporation"]["response"] }}
                                </div>
                                <ng-container *ngFor="let product of company.products;let i= index">
                                    <div *ngIf="i!=0" [class.last-item]="i==company.products.length-1">
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-container>

                    </td>
                    <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <div class="revenue-edit-controls" *ngFor="let product of company.products;let ind=index">
                                <button *ngIf="assistMode" class="img-icon-button" (click)="showProductRevenueControls(product)">
                                <img *ngIf="product.showRevenue" src="assets/images/checkmark.png">
                                <img *ngIf="!product.showRevenue" src="assets/images/plier-icon.png">
                            </button>
                                <div [class.last-item]="ind==company.products.length-1">
                                    <div *ngIf="product.technicalDocumentationLinks&&product.technicalDocumentationLinks.length>0" class="product-target-link" (click)="openLinksDialog(product)">
                                        <a class="black-underline"> Links ({{product.technicalDocumentationLinks.length}})</a>
                                    </div>
                                    <!-- case where no links  -->
                                    <div *ngIf="!product.technicalDocumentationLinks||product.technicalDocumentationLinks.length==0" class="product-target-link">
                                        Unkown
                                    </div>

                                    <!-- <ng-container *ngIf="product.revenue.response">
                                        {{product.revenue?.response?.length()}}
                                    </ng-container> -->
                                </div>
                                <ng-container *ngIf="assistMode">

                                    <button *ngIf="product.showRevenue" class="img-icon-button" (click)="handleInputLinkUpdate(company, product)">
                                    <img src="assets/images/edit-link-icon.png">
                                </button>
                                    <button *ngIf="product.showRevenue" class="img-icon-button" (click)="handleFileLinkUpdate(company, product)">
                                    <img src="assets/images/upload-file-icon.png">
                                </button>
                                </ng-container>
                            </div>
                        </ng-container>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>
    <div *ngIf="currentStage === 4" class="table-container claim-chart-table">
        <div class="claim-charts-heading">
            <div class="claim-charts-heading-text">
                Claim Charts
            </div>
            <div class="expand-collapse-button" (click)="expandAllReferences()" [style]="{cursor:'pointer'}">

                <svg [style]="{
                transform: allExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                }" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 13L12 18L17 13" stroke="#FF5100" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7 6L12 11L17 6" stroke="#FF5100" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <ng-container *ngIf="!allExpanded">
                    Expand
                </ng-container>
                <ng-container *ngIf="allExpanded">
                    Collapse
                </ng-container>

            </div>
        </div>
        <div *ngFor="let claimData of claimChartData; let i=index">
            <ng-container *ngIf="claimData.isError">
                <div class="claim-chart-iterable-heading claim-chart-iterable-heading-error" [id]="''+claimData.patent_number+' vs. '+claimData.targeted_product+i">
                    <span class="dot red"></span>
                    <div>{{claimData.patent_number}} vs. {{claimData.targeted_product}}</div>
                    <span class="failed-badge">FAILED</span>
                    <button class="retry-button" (click)="regenerateClaimChart(claimData.patent_number, claimData.targeted_product); $event.stopPropagation()">
                        <span class="icon">&#x21bb;</span> Retry
                      </button>
                    <div class="reference-arrow-container">

                        <button class="reference-arrow" [class.arrow-closed]="!referenceDivOpenMap(claimData.patent_number+''+i, i)" (click)="toggleReferenceDiv(claimData.patent_number+''+i)">
                            <svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 11.5L11 2.5L2 11.5" stroke="black" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="reference-div-body" [class.body-open]="referenceDivOpenMap(claimData.patent_number+''+i, i)">
                    <div class="claim-chart-error">
                        <div class="error-label">
                            <strong>Error Details</strong>
                        </div>
                        <div class="error-message">
                            {{ claimData.error?.message || 'An unexpected error occurred.' }}
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!claimData.isError">

                <div [id]="''+claimData.patent_number+' vs. '+claimData.targeted_product+i">

                    <div class="claim-chart-iterable-heading">
                        <div>{{claimData.patent_number}} vs. {{claimData.targeted_product}}</div>


                        <img src="assets/images/regenerate-icon.png" (click)="regenerateClaimChart(claimData.patent_number, claimData.targeted_product)">
                        <img src="assets/images/edit-link-icon.png" (click)="openEditLinksDialog( claimData.targeted_product, claimData.patent_number)">
                        <div class="d-flex">
                            <button class="borderless-button" (click)="openEditDialog(claimData)"><svg width="24" height="24" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.4167 6.33337H6.33341C5.49356 6.33337 4.68811 6.667 4.09424 7.26087C3.50038 7.85473 3.16675 8.66019 3.16675 9.50004V31.6667C3.16675 32.5066 3.50038 33.312 4.09424 33.9059C4.68811 34.4997 5.49356 34.8334 6.33341 34.8334H28.5001C29.3399 34.8334 30.1454 34.4997 30.7393 33.9059C31.3331 33.312 31.6667 32.5066 31.6667 31.6667V20.5834" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M29.2917 3.95837C29.9216 3.32848 30.7759 2.97461 31.6667 2.97461C32.5575 2.97461 33.4119 3.32848 34.0417 3.95837C34.6716 4.58826 35.0255 5.44257 35.0255 6.33337C35.0255 7.22416 34.6716 8.07848 34.0417 8.70837L19.0001 23.75L12.6667 25.3334L14.2501 19L29.2917 3.95837Z" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                            <button class=" borderless-button export-button" (click)="toggleShareMenu(''+claimData.patent_number+i)"><svg width="24" height="24" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M26 20L26 23.3333C26 23.7754 25.8127 24.1993 25.4793 24.5118C25.1459 24.8244 24.6937 25 24.2222 25L11.7778 25C11.3063 25 10.8541 24.8244 10.5207 24.5118C10.1873 24.1993 10 23.7754 10 23.3333L10 20" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M22 15L18 11L14 15" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18 11L18 21" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <circle cx="18" cy="18" r="16.5" stroke="black" stroke-width="3"/>
                            </svg>
                            </button>

                            <div *ngIf="showShareMenu[''+claimData.patent_number+i]" class="share-menu-native" appClickOutside (clickOutside)="clickOutsideShareMenu($event)">

                                <!-- Export as Docx -->
                                <div class="menu-item menu-item-greyed-out" (click)="exportPDF(''+claimData.patent_number+' vs. '+claimData.targeted_product+i)">
                                    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.00008 7.33333V12.3333M7.00008 12.3333L4.50008 9.83333M7.00008 12.3333L9.50008 9.83333M11.1667 16.5H2.83341C2.39139 16.5 1.96746 16.3244 1.6549 16.0118C1.34234 15.6993 1.16675 15.2754 1.16675 14.8333V3.16667C1.16675 2.72464 1.34234 2.30072 1.6549 1.98816C1.96746 1.67559 2.39139 1.5 2.83341 1.5H7.48842C7.70941 1.50005 7.92134 1.58788 8.07758 1.74417L12.5892 6.25583C12.7455 6.41208 12.8334 6.624 12.8334 6.845V14.8333C12.8334 15.2754 12.6578 15.6993 12.3453 16.0118C12.0327 16.3244 11.6088 16.5 11.1667 16.5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>

                                    <span class="menu-label">Export as PDF</span>
                                    <div class="coming-soon-label">Coming Soon</div>
                                </div>

                                <hr />
                                <!-- Export as PDF -->
                                <div class="menu-item" (click)="exportClaimChartToDocx(claimData)">
                                    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.50008 9.83333H7.00012H9.50008M4.50012 12.8333H7.00016H9.50012M4.50012 6.83325H7.00016H9.50012M11.1667 16.5H2.83341C2.39139 16.5 1.96746 16.3244 1.6549 16.0118C1.34234 15.6993 1.16675 15.2754 1.16675 14.8333V3.16667C1.16675 2.72464 1.34234 2.30072 1.6549 1.98816C1.96746 1.67559 2.39139 1.5 2.83341 1.5H7.48842C7.70941 1.50005 7.92134 1.58788 8.07758 1.74417L12.5892 6.25583C12.7455 6.41208 12.8334 6.624 12.8334 6.845V14.8333C12.8334 15.2754 12.6578 15.6993 12.3453 16.0118C12.0327 16.3244 11.6088 16.5 11.1667 16.5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>

                                    <span class="menu-label">Export as Word</span>
                                </div>
                            </div>
                            <div class="reference-arrow-container">

                                <button class="reference-arrow" [class.arrow-closed]="!referenceDivOpenMap(claimData.patent_number+''+i, i)" (click)="toggleReferenceDiv(claimData.patent_number+''+i)">
                                <svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 11.5L11 2.5L2 11.5" stroke="black" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                            </div>
                        </div>
                    </div>
                    <div class="reference-div-body" [class.body-open]="referenceDivOpenMap(claimData.patent_number+''+i, i)">

                        <table>
                            <thead>
                                <tr>
                                    <th>Claims</th>
                                    <th>Infringement</th>
                                    <th>Score</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="claim-chart-iterable" *ngFor="let claimElement of claimData.data; let j=index">
                                    <td>
                                        <div class="claim-element-td-container">
                                            {{claimElement.claim_element}}
                                        </div>
                                    </td>
                                    <td class="claim-analyst-comment-td">
                                        <div class="claim-element-td-container">
                                            <!-- Analyst comment -->
                                            <div class="individual-part-claim-element">
                                                <b>Analyst Comment:</b> {{ claimElement.analyst_comment }}
                                            </div>
                                            <!-- Loop over each reference + its source -->
                                            <ng-container *ngFor="let ref of claimElement.references; let i = index">
                                                <div class="individual-part-claim-element">
                                                    <b>Reference {{ i + 1 }}:</b> {{ ref.reference }}
                                                </div>
                                                <div class="individual-part-claim-element" *ngIf="ref.source">
                                                    <b>Source:</b>
                                                    <span [innerHTML]="getLinkOrText(ref.source)"></span>
                                                </div>
                                                <div class="individual-part-claim-element" *ngIf="ref.relavanceIndex">
                                                    <b>Similarity Grade:</b> {{roundFirstTenth(ref.relavanceIndex)}}%
                                                </div>
                                            </ng-container>
                                            <!-- Fallback if no references at all -->
                                            <div class="individual-part-claim-element" *ngIf="!claimElement.references?.length">
                                                <em>No references available</em>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="claim-element-td-container">
                                            <ng-container *ngIf="j==0">
                                                <!-- {{claimData.score}} -->
                                                <app-validity-score [infringementScore]="true" [score]="claimData.score"></app-validity-score>
                                            </ng-container>
                                        </div>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </ng-container>

        </div>

    </div>
    <div *ngIf="currentStage === 5" class="table-container revenue-identification">
        <table>
            <thead>
                <tr>
                    <th>S. No.</th>
                    <th>Patent Number</th>
                    <th>Targeted Company</th>
                    <th>Targeted Product</th>
                    <th>Infringement Score</th>
                </tr>
            </thead>
            <tbody class="limited-div-container">
                <tr *ngFor="let patent of patentDetails; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>
                        <!-- {{ patent.patentNumber }} -->
                        <a href="https://patents.google.com/patent/{{ patent.patentNumber }}" target="_blank">
                            {{ patent.patentNumber  }}
                        </a>
                    </td>
                    <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <div>
                                {{ company.name }}
                            </div>
                            <ng-container *ngFor="let product of company.products;let k= index">
                                <div *ngIf="k!=0" [class.last-item]="k==company.products.length-1">
                                </div>
                            </ng-container>
                        </ng-container>
                    </td>

                    <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <ng-container *ngFor="let product of company.products;let ind=index">

                                <div [class.last-item]="ind==company.products.length-1">
                                    {{ product.name }}
                                </div>
                            </ng-container>
                        </ng-container>
                    </td>
                    <td>
                        <!-- {{patentInfringementScoreData[patent.patentNumber]}} -->
                        <ng-container *ngIf="patentInfringementScoreData[patent.patentNumber]">
                            <app-validity-score [infringementScore]="true" [score]="patentInfringementScoreData[patent.patentNumber]"></app-validity-score>
                        </ng-container>
                    </td>

                </tr>
            </tbody>
        </table>

    </div>

</div>